import { CustomFieldDefinition } from '@alucio/aws-beacon-amplify/src/models'
import { CustomFieldValuesMap, UserORM } from 'src/types/orms'
import { StaticFields } from 'src/components/CustomFields/ComposableForm'

// redux
import { useUserById } from 'src/state/redux/selector/user';
import {
  getUserEditDefaultValues,
  userEditConfig,
} from './UserEditConfig';
import { useMemo } from 'react';

interface UserEditFormConfig {
  customFields: CustomFieldDefinition[],
  userORM?: UserORM,
  staticFields: StaticFields,
  values: CustomFieldValuesMap,
}

const useUserEditFormConfig = (userId?: string): UserEditFormConfig => {
  const userORM = useUserById(userId || '');
  // this is a workaround because we are using composableForm in this component and composableForm expects customFields
  // but the customFields value is being managed by local state.
  const customFields: CustomFieldDefinition[] = []
  const defaultValues = useMemo(() => getUserEditDefaultValues(userORM), [userORM])

  return {
    customFields,
    userORM,
    values: defaultValues,
    staticFields: { ...userEditConfig },
  }
}

export default useUserEditFormConfig
